import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n from '@/plugins/i18n'
import logger from '@/services/logger'
import { loader, loaderAnimation, modal, progressBar, toaster, toggle, toggles } from 'shared'
import modalAutomixUpdate from '@/components/ModalAutomixUpdate.vue'
import modalCallRoomParticipants from '@/components/ModalCallRoomParticipants.vue'
import modalCallRoomSession from '@/components/ModalCallRoomSession.vue'
import modalCatcherSettings from '@/components/ModalCatcherSettings.vue'
import modalConfirmation from '@/components/ModalConfirmation.vue'
import modalContact from '@/components/ModalContact.vue'
import modalContributionInvite from '@/components/ModalContributionInvite.vue'
import modalCreateDistributor from '@/components/ModalCreateDistributor.vue'
import modalDistributorMaxCountReached from '@/components/ModalDistributorMaxCountReached.vue'
import modalEventFilesAvailable from '@/components/ModalEventFilesAvailable.vue'
import modalEventUpdate from '@/components/ModalEventUpdate.vue'
import modalFacebookSelect from '@/components/ModalFacebookSelect.vue'
import modalInvalidBrowser from '@/components/ModalInvalidBrowser.vue'
import modalInvalidDevice from '@/components/ModalInvalidDevice.vue'
import modalLinkedinSelect from '@/components/ModalLinkedinSelect.vue'
import modalListDistributors from '@/components/ModalListDistributors.vue'
import modalLogout from '@/components/ModalLogout.vue'
import modalMessageCatcher from '@/components/ModalMessageCatcher.vue'
import modalMessageContributors from '@/components/ModalMessageContributors.vue'
import modalNoWebConsole from '@/components/ModalNoWebConsole.vue'
import modalOrientation from '@/components/ModalOrientation.vue'
import modalStartLiveError from '@/components/ModalStartLiveError.vue'
import modalStartLiveNoDistributors from '@/components/ModalStartLiveNoDistributors.vue'
import modalTextUpdate from '@/components/ModalTextUpdate.vue'
import modalTooManyEvents from '@/components/ModalTooManyEvents.vue'
import modalUnblockSound from '@/components/ModalUnblockSound.vue'
import modalUserFileCreate from '@/components/ModalUserFileCreate.vue'
import navigation from '@/components/Navigation.vue'
import progresser from '@/components/Progresser.vue'
import ratio from '@/components/Ratio.vue'
import selector from '@/components/Selector.vue'
import simplebar from 'simplebar-vue'
import svgAudio from '@/components/SvgAudio.vue'
import auth from '@/services/auth'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faClone, faCog, faCommentDots, faFilm, faImage, faMicrophone, faMicrophoneSlash, faMusic, faPencilAlt, faSignal, faSlash, faSlidersH, faTrash, faUserMinus, faUserPlus, faUsers } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// We need to set the router here since there's a cyclic dependence between auth and router
auth.setRouter(router)

library.add(faClone, faCog, faCommentDots, faFilm, faImage, faMicrophone, faMicrophoneSlash, faMusic, faPencilAlt, faSignal, faSlash, faSlidersH, faTrash, faUserMinus, faUserPlus, faUsers)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

// Logger
logger.showDebugError()
Vue.config.errorHandler = (err, vm, info) => { logger.error(err) }
window.onerror = function (msg, url, line, col, err) { logger.error(err) }

Vue.component('loader', loader)
Vue.component('loaderAnimation', loaderAnimation)
Vue.component('modal', modal)
Vue.component('modalAutomixUpdate', modalAutomixUpdate)
Vue.component('modalCallRoomParticipants', modalCallRoomParticipants)
Vue.component('modalCallRoomSession', modalCallRoomSession)
Vue.component('modalCatcherSettings', modalCatcherSettings)
Vue.component('modalConfirmation', modalConfirmation)
Vue.component('modalContact', modalContact)
Vue.component('modalContributionInvite', modalContributionInvite)
Vue.component('modalCreateDistributor', modalCreateDistributor)
Vue.component('modalDistributorMaxCountReached', modalDistributorMaxCountReached)
Vue.component('modalEventFilesAvailable', modalEventFilesAvailable)
Vue.component('modalEventUpdate', modalEventUpdate)
Vue.component('modalFacebookSelect', modalFacebookSelect)
Vue.component('modalInvalidBrowser', modalInvalidBrowser)
Vue.component('modalInvalidDevice', modalInvalidDevice)
Vue.component('modalLinkedinSelect', modalLinkedinSelect)
Vue.component('modalListDistributors', modalListDistributors)
Vue.component('modalLogout', modalLogout)
Vue.component('modalMessageCatcher', modalMessageCatcher)
Vue.component('modalMessageContributors', modalMessageContributors)
Vue.component('modalNoWebConsole', modalNoWebConsole)
Vue.component('modalOrientation', modalOrientation)
Vue.component('modalStartLiveError', modalStartLiveError)
Vue.component('modalStartLiveNoDistributors', modalStartLiveNoDistributors)
Vue.component('modalTextUpdate', modalTextUpdate)
Vue.component('modalTooManyEvents', modalTooManyEvents)
Vue.component('modalUnblockSound', modalUnblockSound)
Vue.component('modalUserFileCreate', modalUserFileCreate)
Vue.component('navigation', navigation)
Vue.component('progressBar', progressBar)
Vue.component('progresser', progresser)
Vue.component('ratio', ratio)
Vue.component('selector', selector)
Vue.component('simplebar', simplebar)
Vue.component('svgAudio', svgAudio)
Vue.component('toaster', toaster)
Vue.component('toggle', toggle)
Vue.component('toggles', toggles)

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
